import { AlertRow } from '@components/AlertCenter/AlertRows/AlertRow';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@services/hooks/translations/useTranslations';
import { PartnerSettingsAvatar } from '@components/AlertCenter/AlertRows/partnerSettings/PartnerSettingsAvatar';

export const PartnerLogotypeAlertRow = () => {
  const {
    translate,
    translations: {
      alertCenter: { partnerSettings },
    },
  } = useTranslations();

  const navigate = useNavigate();

  const goToSettings = () => {
    navigate(`/system-settings/company-information?modal=partnerLogotype`);
  };

  return (
    <AlertRow
      Icon={<PartnerSettingsAvatar />}
      action={goToSettings}
      title={translate(partnerSettings.partnerLogotype.title)}
      actionText={translate(partnerSettings.partnerLogotype.path)}
      subtitle={translate(partnerSettings.subtitle)}
    />
  );
};
